import { FC } from "react";
import { Filter } from "react-admin";

import SearchWithQuery from "../../../../components/CustomSearch/SearchWithQuery";
import useCurrentUser from "../../../../hooks/useCurrentUser";
import { productsCollRef } from "../../../../utils/referencies";

const ProductsFilters: FC<any> = (props) => {
  const { user } = useCurrentUser();

  return (
    <>
      <Filter {...props}>
        <SearchWithQuery query={productsCollRef.where("brandId", "==", user.id)} source="title.en" label="Title" />
      </Filter>
    </>
  );
};

export default ProductsFilters;
